import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-services',
  imports: [NgFor],
  templateUrl: './services.html',
  styleUrl: './services.css',
})
export class Services {
  readonly services = [
    {
      title: 'Selection',
      description:
        'We identify founders with disruptive ideas in any sector—be it agriculture, textiles, or tech',
    },
    {
      title: 'Structural Engineering',
      description:
        'We integrate the venture into the Tricore ecosystem, providing professional governance and operational support.',
    },
    {
      title: 'Empire Building',
      description:
        'We utilize our cross-industry network and scaling expertise to achieve market dominance.',
    },
    {
      title: 'Go-to-Market Activation',
      description:
        'Brand strategy, content, and performance channels work together to build traction and sustained growth.',
    },
  ];
}
